module.exports = {
  points_needed: '{needed} von {total} Punkten',
  attempts_left_of: '{remaining} von {total} übrig',
  attempts_left: '1 Versuch übrig | {attemptsLeft} Versuche übrig',
  duration: '1 Minute | {minutes} Minuten',
  n_points: '1 Punkt | {points} Punkte',
  pass: 'Bestanden',
  filters: {
    passed: 'Bestanden',
    has_certificate: 'Mit Zertifikat',
    expires_soon: 'Nur noch kurz verfügbar',
    not_passed: 'Nicht bestanden',
  },
  submissions: {
    passed: 'Bestanden',
    date: 'Datum',
    no_results: 'Noch keine Versuche abgelegt.',
    question_x_of_y: 'Frage {x} von {y}',
    not_passed: 'Nicht bestanden',
    result: 'Ergebnis',
    status: 'Status',
  },
  passed_percentage: 'Bestanden mit {percentage}%',
  necessary_percentage: 'Bestanden ab:',
  show_all_tests: 'Alle Tests anzeigen',
  not_passed_reason: {
    0: 'Du hast zu viele Fragen falsch beantwortet',
    1: 'Dein Zeitlimit ist abgelaufen',
  },
  sortLabels: {
    name_asc: 'Alphabetisch (A-Z)',
    name_desc: 'Alphabetisch (Z-A)',
    published_at_asc: 'Datum (älteste zuerst)',
    published_at_desc: 'Datum (neuste zuerst)',
  },
  sortShortLabels: {
    name_asc: 'A-Z',
    published_at_asc: 'Älteste',
    published_at_desc: 'Neuste',
    name_desc: 'Z-A',
  },
  earned_certificate: 'Zertifikat erworben',
  continue_test: 'Test fortsetzen',
  with_certificate: 'Mit Zertifikat',
  nice_you_passed: 'Yeah! Du hast bestanden',
  download_certificate: 'Zertifikat herunterladen',
  sadly_not_passed: 'Leider nicht bestanden',
  only_x_days_left: 'Nur noch einen Tag verfügbar | Nur noch {x} Tage verfügbar',
  currently_no_tests_visible: 'Hier gibt es aktuell keine Tests.',
  start_test: 'Test starten',
  available_tries: 'Versuche:',
  questions: 'Fragen:',
  time_limit_label: 'Dein Zeitlimit ist',
  unlimited_repetitions: 'Unbegrenzt',
  no_pass: 'Nicht bestanden',
  not_passed_percentage: 'In Bearbeitung ({percentage}%)',
  repeat_limit: 'einmal wiederholen | {count} Mal wiederholen',
  repeat_limit_label: 'Du kannst den Test',
  answers: 'Antworten',
  your_answers: 'Deine Antworten',
  repeat_test: 'Test wiederholen',
  your_result: 'Dein Ergebnis',
  test_from: 'Testergebnis vom %{date}',
  available_until: 'Deadline:',
  test: 'Test',
  search_test: 'Test suchen',
  tests_todo: 'Ausstehende Tests',
  will_receive_certificate: 'Für das Bestehen dieses Tests erhältst du ein Zertifikat.',
}
